module.exports = __webpack_public_path__ + "static/media/T1.e3c3f9fd.svg";